import axios from "axios";

import { caseLoadTracker } from "../Providers/caseLoadTracker.mjs";

const requestMatchesCase = (url, params, context) => {
  const query = new URLSearchParams(url.search);
  Object.entries(params || {}).forEach(([key, value]) => query.set(key, value));
  const pair =
    url.pathname.match(
      /\/api\/(?:cases|client-providers|casepage-client-providers)\/([^/]+)\/([^/]+)/
    ) || url.pathname.match(/\/client\/([^/]+)\/case\/([^/]+)/);
  const clientId =
    pair?.[1] || query.get("client_id") || url.pathname.match(/\/clients\/([^/]+)/)?.[1];
  const caseId = pair?.[2] || query.get("case_id");
  // Global catalog requests and intentional prefetches for another case are
  // allowed to finish. Only responses belonging to the departed case expire.
  return (
    Boolean(clientId || caseId) &&
    (!clientId || String(clientId) === context.clientId) &&
    (!caseId || String(caseId) === context.caseId)
  );
};

export const installCaseLoadingRequests = (
  client,
  { backendOrigin, tracker = caseLoadTracker }
) => {
  const requestInterceptor = client.interceptors.request.use((config) => {
    const url = new URL(config.url || "", config.baseURL || backendOrigin);
    if (
      url.origin !== new URL(backendOrigin).origin ||
      !url.pathname.startsWith("/api/") ||
      url.pathname.startsWith("/api/auth/") ||
      url.pathname === "/api/general/click_record/" ||
      config.skipCaseLoading
    ) {
      return config;
    }
    const context = tracker.getSnapshot();
    config.__caseLoadRequest = {
      ...tracker.startRequest(),
      guardStale:
        (config.method || "get").toLowerCase() === "get" &&
        requestMatchesCase(url, config.params, context),
    };
    return config;
  });
  const responseInterceptor = client.interceptors.response.use(
    (response) => {
      const request = response.config?.__caseLoadRequest;
      tracker.finishRequest(request);
      if (request?.guardStale && !tracker.isCurrentRequest(request)) {
        throw new axios.CanceledError("The requested case is no longer open.", response.config);
      }
      return response;
    },
    (error) => {
      tracker.finishRequest(error.config?.__caseLoadRequest);
      return Promise.reject(error);
    }
  );
  return () => {
    client.interceptors.request.eject(requestInterceptor);
    client.interceptors.response.eject(responseInterceptor);
  };
};
